// import KeyValuePair from '@/modules/core/support/KeyValuePair'

export default class RegisterPlatformUserData {
    public idEmpresa = ''
    public password = ''
    public role = ''
    public isCreateCompany = false
    public nameCompany = ''
    public serial = ''
    public apiURL = ''
    public roleType = 1
    public idUser = 0
    public isBlockedUser = false
    public isVerifyEmail = false
}
